module.exports = __webpack_public_path__ + "img/multi-three.e9160926.svg";